// Material Web Imports
import '@material/web/tabs/tabs.js';
import '@material/web/tabs/primary-tab.js';
import '@material/web/tabs/secondary-tab.js';
import '@material/web/button/filled-button.js';
import '@material/web/button/outlined-button.js';
import '@material/web/button/text-button.js';
import '@material/web/icon/icon.js';
import '@material/web/iconbutton/icon-button.js';
import '@material/web/divider/divider.js';
import '@material/web/list/list.js';
import '@material/web/list/list-item.js';

// Core Components 
import { FarmhandMcw } from './farmhand-mcw';
import { HomeTabActions } from './home-tab-actions';
import { TabPager } from './tab-pager';
import { StartQuoteController } from './start-quote';
import { Truncate } from './truncate';
import { onReady } from './utils/on-ready';
import { bindComponentsToClass } from './utils/bind-components-to-class';
import { TabPane } from './tab-pane';
import { MegaTab } from './mega-tab';

declare var window: any;

// Legacy scripts 
import './details-shim.js';
import './lazysizes.js';
import './geocode.js';
import './find-agent.js';
import './analytics-tracking.js';
import './faq.js';

// Instantiate Critical Global Objects
window.farmhandMcw = new FarmhandMcw();
window.hta = new HomeTabActions();
window.TabPager = new TabPager();
window.startQuoteController = new StartQuoteController();
window.truncate = new Truncate();

// Initialize Critical Components on DOM Ready
onReady(() => {
    if (window.hta && typeof window.hta.initialize === 'function' && !window.hta._hasInitialized) {
        window.hta._hasInitialized = true;
        window.hta.initialize();
    }
    window.tabPanes = bindComponentsToClass(TabPane.cssClass, el => new TabPane(el));
    window.megaTabs = bindComponentsToClass(MegaTab.cssClass, el => new MegaTab(el));
});